import React from 'react'
import style from '../scss/components/Button.module.scss'
import classNames from 'classnames'

type Props = {
    children: any
    inverted?: boolean
    className?: string | object
    fadeInX?: boolean
    fadeInY?: boolean
    wide?: boolean
    huge?: boolean
    mobile16?: boolean
    onClick?: () => void
}

const Button = (props: Props) => {
    return (
        <button className={classNames(style.Main, {
            [style.Inverted]: props.inverted,
            [style.FadeInX]: props.fadeInX,
            [style.FadeInY]: props.fadeInY,
            [style.Wide]: props.wide,
            [style.Huge]: props.huge,
            [style.Mobile16]: props.mobile16,
        }, props.className)} type="button" onClick={props.onClick}>
            {props.children}
        </button>
    )
}

Button.defaultProps = {
    inverted: false,
    fadeInX: false,
    fadeInY: false,
    wide: false,
    huge: false,
}

export default Button
